import { ApiResourceLink, ApiResourceEmbed } from './api';

export interface RestaurantDTO {
  restaurantNumber: number;
  restaurantName?: string;
  restaurantLocationType?: string;
  restaurantStatus?: string;
  openDate?: string;
  operationalRegion?: string;
  operationalSubRegion?: string;
  operationalPatch?: string;
  designatedMarketAreaName?: string;
  restaurantOpen?: boolean;
  currency?: ApiResourceLink<{ currencyCode: string }>;
  country?: ApiResourceLink<{ countryCode: string }>;
  addresses?: ApiResourceEmbed<RestaurantAddress[]>;
  directions?: ApiResourceEmbed<RestaurantDirections>;
  otherPhones?: ApiResourceLink[];
  contactInformation?: ApiResourceLink;
  realEstate?: ApiResourceLink;
  marketing?: ApiResourceLink;
  normalHours?: ApiResourceLink[];
  realHours?: ApiResourceEmbed<StoreHours[]>;
  onlineOrdering?: ApiResourceEmbed<OnlineOrdering>;
  eventMessages?: ApiResourceLink[];
  catering?: ApiResourceEmbed<Catering>;
  delivery?: ApiResourceLink;
  timezone?: ApiResourceEmbed<Timezone>;
  chipotlane?: ApiResourceEmbed<Chipotlane>;
  sustainability?: ApiResourceEmbed<Sustainability>;
  experience?: ApiResourceEmbed<Experience>;
}

export interface Restaurant {
  restaurantNumber: number;
  restaurantName?: string;
  address: RestaurantAddress;
  directions?: RestaurantDirections;
  hours: StoreHours[];
  restaurantStatus?: string;
  onlineOrderingEnabled: boolean;
  cateringEnabled: boolean;
  currentTimezoneOffset: number;
  chipotlanePickupEnabled: boolean;
  utensilsEnabled: boolean;
  utensilsShow: boolean;
  digitalKitchen: boolean;
  walkupWindowEnabled: boolean;
  pickupInsideEnabled: boolean;
  crewTipPickupEnabled: boolean;
  crewTipDeliveryEnabled: boolean;
  diningRoomOpen: boolean;
}

export interface RestaurantAddress {
  addressType?: string;
  addressLine1?: string;
  locality?: string;
  administrativeArea?: string;
  postalCode?: string;
  subAdministrativeArea?: string;
  countryCode?: string;
  latitude?: number;
  longitude?: number;
  accuracyDetermination?: string;
}

export interface RestaurantDirections {
  landmark?: string;
  crossStreet1?: string;
  crossStreet2?: string;
  pickupInstructions?: string;
}

// Restaurant service does not return open and close times if restaurant is closed that day
export interface StoreHours {
  dayOfWeek: string;
  openDateTime?: string;
  closeDateTime?: string;
}

export interface OnlineOrdering {
  onlineOrderingEnabled: boolean;
}

export interface Catering {
  cateringEnabled: boolean;
}

export interface Timezone {
  currentTimezoneOffset: number;
  daylightSavingsOffset: number;
  observeDaylightSavings: string;
  timezone: string;
  timezoneId: string;
  timezoneOffset: number;
}

export interface Epop {
  title: string;
  message: string;
}

export interface Chipotlane {
  chipotlanePickupEnabled: boolean;
}

export enum DefaultUtensilsType {
  OPTIN = 'OPT-IN',
  OPTOUT = 'OPT-OUT',
  NA = 'NA',
}
export interface Sustainability {
  utensilsDefaultState: DefaultUtensilsType;
}

export interface Experience {
  digitalKitchen: boolean;
  walkupWindowEnabled: boolean;
  pickupInsideEnabled: boolean;
  crewTipPickupEnabled: boolean;
  crewTipDeliveryEnabled: boolean;
  diningRoomOpen: boolean;
}

export enum PickupOption {
  WalkUp = 'Walk-up',
  Chipotlane = 'Chipotlane',
  Pickup = 'Pickup',
  DigitalKitchen = 'Digital Kitchen',
}